module.exports = __webpack_public_path__ + "img/triangle.473dc2b3.svg";